export const GET_SHARE_LIST = "GET-SHARE-LIST";
export const GET_SHARE_LIST_FILTERS = "GET-SHARE-LIST-FILTERS";
